'use client';

import type { ComparisonResult } from '@/lib/audit/cross-device-comparison';
import styles from '@/components/audit/ProReportResults.module.css';

interface ComparisonStatsProps {
  comparison: ComparisonResult;
  locale?: string;
}

export function ComparisonStats({ comparison, locale = 'en' }: ComparisonStatsProps) {
  const isSpanish = locale === 'es';

  return (
    <section className={styles.comparisonSection}>
      <div className={styles.comparisonStats}>
        <div className={styles.comparisonStat}>
          <span className={styles.comparisonStatNumber}>{comparison.summary.sharedCount}</span>
          <span className={styles.comparisonStatLabel}>
            {isSpanish ? 'Problemas Compartidos' : 'Shared Issues'}
          </span>
          <span className={styles.comparisonStatNote}>
            {isSpanish ? 'Encontrados en ambos' : 'Found on both devices'}
          </span>
        </div>
        <div className={styles.comparisonStat}>
          <span className={styles.comparisonStatNumber}>
            {comparison.summary.desktopOnlyCount}
          </span>
          <span className={styles.comparisonStatLabel}>
            {isSpanish ? 'Solo Escritorio' : 'Desktop Only'}
          </span>
          <span className={styles.comparisonStatNote}>
            {isSpanish ? 'Unico en escritorio' : 'Unique to desktop'}
          </span>
        </div>
        <div className={styles.comparisonStat}>
          <span className={styles.comparisonStatNumber}>{comparison.summary.mobileOnlyCount}</span>
          <span className={styles.comparisonStatLabel}>
            {isSpanish ? 'Solo Movil' : 'Mobile Only'}
          </span>
          <span className={styles.comparisonStatNote}>
            {isSpanish ? 'Unico en movil' : 'Unique to mobile'}
          </span>
        </div>
        <div className={styles.comparisonStat}>
          <span className={styles.comparisonStatNumber}>
            {comparison.summary.sharedPercentage}%
          </span>
          <span className={styles.comparisonStatLabel}>
            {isSpanish ? 'Coincidencia' : 'Overlap'}
          </span>
          <span className={styles.comparisonStatNote}>
            {isSpanish ? 'Problemas en ambos' : 'Issues on both'}
          </span>
        </div>
      </div>
    </section>
  );
}
